module.exports = __webpack_public_path__ + "assets/img/00050.4fe15f1c.png";